import { Box } from "@mui/material";
import { Checkbox, Typography } from "@platform/design-system";

export const GroupByBrokerCheckbox = (): React.JSX.Element => (
  <Box
    data-testid="group-by-broker-checkbox"
    component="label"
    display="flex"
    alignItems="center"
  >
    <Checkbox />
    <Typography variant="body-medium" component="span">
      Group by broker
    </Typography>
  </Box>
);
